
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 485.411 485.411"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 81.824v321.763h485.411V81.824H0zm242.708 198.702L43.612 105.691h398.187L242.708 280.526zm-79.311-37.877L23.867 365.178V120.119l139.53 122.53zm18.085 15.884l61.22 53.762 61.22-53.762L441.924 379.72H43.487l137.995-121.187zm140.526-15.878l139.535-122.536v245.059L322.008 242.655z"}})])
          )
        }
      }
    